import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from 'vue'
import { useToggle } from '@vueuse/core'


export default /*@__PURE__*/_defineComponent({
  __name: 'UiEllipsisContent',
  props: {
    lines: { default: undefined }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const [state, toggle] = useToggle(false)
const el = ref<HTMLElement | null>(null)
const isShowButton = ref(false)

const props = __props
function getLineHeight(el: HTMLElement) {
  const temp = document.createElement(el.nodeName)
  temp.setAttribute(
    'style',
    'margin:0; padding:0; ' +
      'font-family:' +
      (el.style.fontFamily || 'inherit') +
      '; ' +
      'font-size:' +
      (el.style.fontSize || 'inherit')
  )
  temp.innerHTML = 'A'
  if (el.parentNode) {
    el.parentNode.appendChild(temp)
  }
  const ret = temp.clientHeight
  if (temp.parentNode) {
    temp.parentNode.removeChild(temp)
  }

  return ret
}
onMounted(() => {
  if (el.value && props.lines) {
    if (el.value.scrollHeight > getLineHeight(el.value) * props.lines) {
      isShowButton.value = true
    }
  }
})
const bounded = computed(() => ({
  state: state.value,
  toggle,
}))

const __returned__ = { state, toggle, el, isShowButton, props, getLineHeight, bounded, computed, ref, onMounted, get useToggle() { return useToggle } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})